import startCase from 'lodash/startCase';
import converter from 'number-to-words';

export default function makeStepTitle(step, title) {
  return `Step ${startCase(converter.toWords(step))}: ${title}`;
}
